import { List } from "immutable";

import { makeGetNumberOfIncompleteAssignmentsSections } from "seneca-common/features/assignments/features/student-assignments/selectors/makeGetNumberOfIncompleteAssignmentsSections";
import { useMemoSelector } from "seneca-common/utils/hooks/selectors";

import useGetAssignmentIds from "./useGetAssignmentIds";

export default function useGetNumberOfUnstudiedSectionsAcrossAssignmentsForCourse() {
  const { assignmentIds } = useGetAssignmentIds();

  const numberOfIncompleteAssignmentSections = useMemoSelector(
    makeGetNumberOfIncompleteAssignmentsSections,
    List(assignmentIds)
  );

  return numberOfIncompleteAssignmentSections;
}
